export function getElementScreenCordinate(element) {
  const rect = element.getBoundingClientRect();

  return { x: rect.left, y: rect.top };
}

export function getElementCenterScreenCordinate(element) {
  const rect = element.getBoundingClientRect();

  return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
}

export function getElementTopLeftScreenCordinate(element) {
  const rect = element.getBoundingClientRect();

  return { x: rect.left, y: rect.top };
}

export function getElementRandomScreenCordinate(element) {
  const rect = element.getBoundingClientRect();
  const biasLeft = Math.pow(Math.random(), 2);

  return {
    x: rect.left + biasLeft * rect.width,
    y: rect.top + Math.random() * rect.height,
  };
}
